import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronDown, Shield, Sparkles, Car, Gem } from "lucide-react";

const BANNER_URL = "https://customer-assets.emergentagent.com/job_98738aa4-d15a-49a5-91ed-b440272a52f8/artifacts/ycwq5ecm_489609005_1216574520471089_8830070208935895582_n.jpg";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_98738aa4-d15a-49a5-91ed-b440272a52f8/artifacts/7wqqh2d2_545628516_1346832964111910_2241672968598432666_n__1_-removebg-preview.png";

const GALLERY_PREVIEW = [
  "https://customer-assets.emergentagent.com/job_98738aa4-d15a-49a5-91ed-b440272a52f8/artifacts/ycwq5ecm_489609005_1216574520471089_8830070208935895582_n.jpg",
  "https://customer-assets.emergentagent.com/job_lsk-auto-styling-1/artifacts/dppje5mc_517438619_1298323068962900_8116375658812081993_n.jpg",
  "https://customer-assets.emergentagent.com/job_lsk-auto-styling-1/artifacts/ysw4rzqd_495575064_1246474497481091_5684810050069620295_n.jpg",
];

const stats = [
  { value: "500+", label: "Mașini Tratate" },
  { value: "8+", label: "Ani Experiență" },
  { value: "100%", label: "Clienți Mulțumiți" },
  { value: "15+", label: "Servicii Oferite" },
];

const featuredServices = [
  { icon: Sparkles, title: "Detailing Complet", desc: "Interior și exterior, la cele mai înalte standarde profesionale." },
  { icon: Shield, title: "Protecție Ceramică", desc: "Protecție de lungă durată pentru vopseaua mașinii tale." },
  { icon: Gem, title: "Polish Profesional", desc: "Corecție vopsea și luciu de showroom pentru vehiculul tău." },
  { icon: Car, title: "PPF & Colantări", desc: "Folie de protecție și personalizare completă a vehiculului." },
];

export default function Home() {
  return (
    <div data-testid="home-page">
      {/* Hero */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={BANNER_URL}
            alt="LSK Auto Styling Center"
            className="w-full h-full object-cover"
          />
          <div className="hero-gradient absolute inset-0" />
          <div className="hex-overlay absolute inset-0" />
        </div>

        <div className="relative z-10 text-center px-6 max-w-4xl">
          <motion.h1
            className="text-5xl sm:text-6xl lg:text-8xl font-bold mb-6"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            style={{ textShadow: '0 4px 40px rgba(0,0,0,0.95), 0 0 80px rgba(0,0,0,0.8)' }}
          >
            Excelență în{" "}
            <span className="text-red-600">Detailing Auto</span>
          </motion.h1>
          <motion.p
            className="text-lg md:text-xl mb-10 font-medium max-w-2xl mx-auto"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            style={{ fontFamily: "'Raleway', sans-serif", textShadow: '0 2px 30px rgba(0,0,0,0.95)' }}
          >
            Transformăm fiecare mașină într-o operă de artă
          </motion.p>
          <motion.div
            className="flex flex-col sm:flex-row gap-4 justify-center"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.7 }}
          >
            <Link
              to="/servicii"
              data-testid="hero-services-btn"
              className="px-8 py-3 bg-red-600 text-white hover:bg-red-700 hover:shadow-[0_0_30px_rgba(220,38,38,0.4)] transition-all duration-300 tracking-[0.15em] uppercase text-sm font-medium"
              style={{ fontFamily: "'Raleway', sans-serif" }}
            >
              Descoperă Serviciile
            </Link>
            <Link
              to="/contact"
              data-testid="hero-contact-btn"
              className="px-8 py-3 border border-white text-white hover:bg-white hover:text-black transition-all duration-300 tracking-[0.15em] uppercase text-sm font-medium"
              style={{ fontFamily: "'Raleway', sans-serif" }}
            >
              Solicită Ofertă
            </Link>
          </motion.div>
        </div>

        <motion.div
          className="absolute bottom-8 left-1/2 -translate-x-1/2"
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <ChevronDown className="w-8 h-8 text-red-600" />
        </motion.div>
      </section>

      {/* Stats */}
      <section className="py-20 bg-black border-y border-white/10">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, i) => (
            <motion.div
              key={stat.label}
              className="text-center"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="text-4xl md:text-5xl font-bold text-red-600" style={{ fontFamily: "'Playfair Display', serif" }}>
                {stat.value}
              </div>
              <div className="text-xs tracking-[0.15em] uppercase mt-2 font-medium" style={{ fontFamily: "'Raleway', sans-serif" }}>
                {stat.label}
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Featured Services */}
      <section className="py-24 bg-[#050505]">
        <div className="max-w-7xl mx-auto px-6">
          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl sm:text-4xl lg:text-5xl mb-4">
              Servicii de <span className="text-red-600">Top</span>
            </h2>
            <div className="red-line mx-auto" />
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {featuredServices.map((service, i) => (
              <motion.div
                key={service.title}
                className="shine-card group p-8 bg-[#0A0A0A] border border-[#222] hover:border-red-600 transition-all duration-500"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                viewport={{ once: true }}
                data-testid={`featured-service-${i}`}
              >
                <service.icon className="w-12 h-12 text-red-600 mb-6" />
                <h3 className="text-xl mb-3">{service.title}</h3>
                <p className="text-white font-light text-sm leading-relaxed" style={{ fontFamily: "'Raleway', sans-serif" }}>
                  {service.desc}
                </p>
              </motion.div>
            ))}
          </div>

          <motion.div
            className="text-center mt-12"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <Link
              to="/servicii"
              data-testid="view-all-services-btn"
              className="inline-block px-8 py-3 border border-red-600 text-white hover:bg-red-600 transition-all duration-300 tracking-[0.15em] uppercase text-sm font-medium"
              style={{ fontFamily: "'Raleway', sans-serif" }}
            >
              Toate Serviciile
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Gallery Preview */}
      <section className="py-24 bg-black">
        <div className="max-w-7xl mx-auto px-6">
          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl sm:text-4xl lg:text-5xl mb-4">
              Lucrari <span className="text-red-600">Recente</span>
            </h2>
            <div className="red-line mx-auto" />
          </motion.div>

          <div className="grid md:grid-cols-3 gap-6">
            {GALLERY_PREVIEW.map((img, i) => (
              <motion.div
                key={i}
                className="gallery-item relative aspect-[4/3] overflow-hidden cursor-pointer"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: i * 0.15 }}
                viewport={{ once: true }}
              >
                <img src={img} alt={`Lucrare ${i + 1}`} className="w-full h-full object-cover" />
                <div className="gallery-overlay absolute inset-0 bg-black/50 flex items-center justify-center">
                  <span className="text-white text-sm tracking-[0.15em] uppercase font-medium" style={{ fontFamily: "'Raleway', sans-serif" }}>
                    Vezi Galeria
                  </span>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div
            className="text-center mt-12"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <Link
              to="/galerie"
              data-testid="view-gallery-btn"
              className="inline-block px-8 py-3 border border-white text-white hover:bg-white hover:text-black transition-all duration-300 tracking-[0.15em] uppercase text-sm font-medium"
              style={{ fontFamily: "'Raleway', sans-serif" }}
            >
              Galerie Completă
            </Link>
          </motion.div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-[#050505] relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(220,38,38,0.08),transparent_70%)]" />
        <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
          <motion.h2
            className="text-3xl sm:text-4xl lg:text-5xl mb-6"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            Pregătit să-ți Transformi{" "}
            <span className="text-red-600">Masina</span>?
          </motion.h2>
          <motion.p
            className="text-base md:text-lg mb-10 font-light"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            style={{ fontFamily: "'Raleway', sans-serif" }}
          >
            Contactează-ne pentru o ofertă personalizată. Echipa noastră de profesioniști te așteaptă.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <Link
              to="/contact"
              data-testid="cta-contact-btn"
              className="inline-block px-10 py-4 bg-red-600 text-white hover:bg-red-700 pulse-glow transition-all duration-300 tracking-[0.15em] uppercase text-sm font-medium"
              style={{ fontFamily: "'Raleway', sans-serif" }}
            >
              Cere Ofertă Acum
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
